import { Polygon } from 'geojson';
import type BoundingBox from '../types/BoundingBox';

const getPolygonForBoundingBox = (boundingBox: BoundingBox): Polygon => {
  const { bottomLeft, bottomRight, topLeft, topRight } = boundingBox;
  return {
    type: 'Polygon',
    coordinates: [[bottomLeft, topLeft, topRight, bottomRight, bottomLeft].map(({ lat, lng }) => [lng, lat])]
  };
};

export default getPolygonForBoundingBox;
